import { useState } from "react";
import { Button, CloseButton, Form, Modal, Spinner } from "react-bootstrap";

interface NewMonitoringModalProps {
    createMonitoring: (name: string, description: string, sensors: string) => void;
    showCreateMonitoring: boolean;
    setShowCreateMonitoring: (show: boolean) => void;
    isLoading: boolean;
}

export default function NewMonitoringModal({ createMonitoring, showCreateMonitoring, setShowCreateMonitoring, isLoading }: NewMonitoringModalProps) {

    const [monitoringName, setMonitoringName] = useState("");
    const [monitoringDescription, setMonitoringDescription] = useState("");
    const [monitoringSensors, setMonitoringSensors] = useState("");

    function clickCreateMonitoring() {
        createMonitoring(monitoringName, monitoringDescription, monitoringSensors);
        setMonitoringName("");
        setMonitoringDescription("");
        setMonitoringSensors("");
    }

    return (
        <Modal show={showCreateMonitoring} onHide={() => setShowCreateMonitoring(false)} style={{color: "white"}} size="lg">
            <Modal.Header className="background-color">
                <Modal.Title className="heading">Create New Monitoring</Modal.Title>
                <CloseButton variant="white" onClick={() => setShowCreateMonitoring(false)} />
            </Modal.Header>
            <Modal.Body className="background-color">
                <Form>
                    <Form.Group controlId="formMonitoringName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name of new monitoring [Hoessbahn]" value={monitoringName} onChange={(e) => setMonitoringName(e.target.value)} />
                    </Form.Group>
                    <Form.Group controlId="formMonitoringDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={monitoringDescription} onChange={(e) => setMonitoringDescription(e.target.value)} />
                    </Form.Group>
                    <Form.Group controlId="formMonitoringSensors">
                        <Form.Label>Sensors</Form.Label>
                        <Form.Control type="text" placeholder="Enter name of sensors to monitor (comma-seperated) [Windpuls_Airdrop_20,Windpuls_Airdrop_21]" value={monitoringSensors} onChange={(e) => setMonitoringSensors(e.target.value)} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer
                style={{ backgroundColor: "#111827", color: "white" }}
            >
                <Button className="wind-btn-outline" onClick={() => setShowCreateMonitoring(false)}>
                    Close
                </Button>
                <Button className="wind-btn" onClick={() => clickCreateMonitoring()}>
                    {isLoading ? <Spinner variant="light" animation="border"/>  : "Create Monitoring"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}